export default __webpack_public_path__ + "static/media/Img0002.d5f1f882.png";